var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTextQuote = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M10.184 7.758c0-2.438 1.031-4.314 4.688-4.314h.047v1.642h-.047c-2.719 0-2.906 1.078-2.906 3.14V9.54h2.906v5.017h-4.688zm-7.102 0c0-2.438 1.032-4.314 4.689-4.314h.046v1.642h-.046c-2.72 0-2.907 1.078-2.907 3.14V9.54h2.907v5.017H3.082z" }) }))); };
export default SvgTextQuote;
